import {
  createTagRequest,
  deleteTagRequest,
  getTagsWithPagination,
  updateTagRequest,
} from '@services/e-visits';
import { call, put, select, takeLatest } from 'typed-redux-saga/macro';
import TStore from '../../types/store';
import { FormValueNames, ModalState, TTagSettingsItem } from '../../types/tags-page';
import { actions } from '../ducks/tags-page';

function* getTagsRequest({ payload }: ReturnType<typeof actions.getTagsRequest>) {
  try {
    const { data } = yield* call(getTagsWithPagination, payload);

    yield* put(
      actions.setTags({
        tags: data.data.tags,
        pagination: data.data.pagination,
      }),
    );
  } catch (error) {
    console.log('getTagsRequest', error);
    yield* call(handleError, error);
    yield* put(actions.setTagsRequestError());
  }
}

function* submitFormSaga({ payload }: ReturnType<typeof actions.submitForm>) {
  try {
    const { activeTag, pagination } = yield select((state: TStore) => ({
      activeTag: state.tagsPage.activeTag,
      pagination: state.tagsPage.pagination,
    }));

    yield* put(actions.setSubmitting(true));

    const data = {
      name: payload[FormValueNames.tagName],
      abbreviation: payload[FormValueNames.abbreviation],
      color: payload[FormValueNames.color],
      settings: [payload[FormValueNames.settings].value as TTagSettingsItem],
    };

    if (activeTag && activeTag.id) {
      yield* call(updateTagRequest, { id: activeTag.id, data });
    } else {
      yield* call(createTagRequest, data);
    }

    yield* put(actions.getTagsRequest(pagination));
    yield* put(actions.setSubmitting(false));
    yield* put(
      actions.setSuccessMessage(
        activeTag && activeTag.id ? 'tags_update_success' : 'tags_create_success',
      ),
    );
    yield* put(actions.setModalStatus(ModalState.closed));
  } catch (error) {
    yield* call(handleError, error);
  }
}

function* deleteTagSaga() {
  try {
    const { activeTag, pagination } = yield select((state: TStore) => ({
      activeTag: state.tagsPage.activeTag,
      pagination: state.tagsPage.pagination,
    }));

    yield* put(actions.setSubmitting(true));

    yield* call(deleteTagRequest, activeTag.id);
    yield* put(actions.getTagsRequest(pagination));
    yield* put(actions.setSubmitting(false));
    yield* put(actions.setSuccessMessage('tags_delete_success'));
    yield* put(actions.setDeleteModalStatus(ModalState.closed));
  } catch (error) {
    yield* call(handleError, error);
    yield* put(actions.setDeleteModalStatus(ModalState.closed));
  }
}

function* handleError(error: any) {
  yield* put(actions.setSubmitting(false));
  yield* put(actions.setErrorMessage('tags_error'));
  console.error(error);
}

function* tagsPageSaga() {
  yield takeLatest(actions.getTagsRequest, getTagsRequest);
  yield takeLatest(actions.submitForm, submitFormSaga);
  yield takeLatest(actions.deleteTag, deleteTagSaga);
}

export default tagsPageSaga;
